import { render, staticRenderFns } from "./ElectricalMaintenanceEdit.vue?vue&type=template&id=a6777d34"
import script from "./ElectricalMaintenanceEdit.vue?vue&type=script&lang=js"
export * from "./ElectricalMaintenanceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports